/*
 * @Descripttion:
 * @Author: etong
 * @Date: 2022-09-28 10:29:39
 * @LastEditors: WangQi
 * @LastEditTime: 2023-02-01 17:41:14
 */
// 订单
const map = {
  originalOrderList: () => import('@/views/order/OriginalOrderList'),
  wdtOrderList: () => import('@/views/order/WdtOrderList'),
  wdtOrderList1: () => import('@/views/order/WdtOrderList1'),
  bhOrderList: () => import('@/views/order/bhOrderList'),
  fxOrderList: () => import('@/views/order/FXPlaceOrder'), // 虚拟下单|订单列表
  orderListQN: () => import('@/views/order/OrderListNew'), // 订单查询列表
  orderDetailQN: () => import('@/views/order/components/OrderDetail'), // 订单查询详情
  orderListQNCopy: () => import('@/views/order/OrderListNew2'), // 订单查询列表
  orderDetailQNCopy: () => import('@/views/order/components/OrderDetail2'), // 订单查询详情
}

export default map
